<template>
  <div class="content-v2">
    <div class="news-list-v2">
      <div class="news-row" v-for="news in newsList" :key="news.id">
        <div class="news-date">
          <span class="md">{{ news.monthDay }}</span>
          <span class="year">{{ news.year }}</span>
        </div>
        <router-link :to="{ path: '/news/detail/' + news.id, query: { type: 'safety' } }" class="news-title-link">
          {{ news.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from '@/api/portal'
import { formatMonthDay, formatYear } from '@/utils/format'

export default {
  name: 'NewsSafetyV2',
  data() {
    return {
      newsList: [
        { id: 101, title: '公司开展年度安全生产大检查活动', monthDay: '04-15', year: '2026' },
        { id: 102, title: '安全知识竞赛圆满落幕', monthDay: '03-28', year: '2026' },
        { id: 103, title: '春季防火安全专题培训', monthDay: '03-10', year: '2026' },
        { id: 104, title: '海外项目安全管理经验分享', monthDay: '02-25', year: '2026' },
        { id: 105, title: '冬季施工安全防范措施落实', monthDay: '01-15', year: '2026' },
        { id: 106, title: '安全标准化建设持续推进', monthDay: '12-20', year: '2025' }
      ]
    }
  },
  created() {
    this.loadNews()
  },
  methods: {
    loadNews() {
      getNewsList({ newsType: 'safety', pageNum: 1, pageSize: 20 }).then(({ rows }) => {
        if (!rows || !rows.length) {
          return
        }
        this.newsList = rows.map(item => ({
          id: item.newsId,
          title: item.newsTitle,
          monthDay: formatMonthDay(item.publishTime),
          year: formatYear(item.publishTime)
        }))
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.news-list-v2 {
  .news-row {
    display: flex;
    align-items: center;
    padding: 24px 0;
    border-bottom: 1px solid #e2e8f0;
    transition: all 0.3s;

    &:hover {
      padding-left: 16px;
      background: rgba(59,130,246,0.03);
    }

    .news-date {
      width: 90px;
      flex-shrink: 0;
      text-align: center;
      margin-right: 30px;

      .md {
        display: block;
        font-size: 28px;
        font-weight: 800;
        color: #3b82f6;
        line-height: 1;
      }

      .year {
        font-size: 13px;
        color: #94a3b8;
      }
    }

    .news-title-link {
      font-size: 17px;
      font-weight: 500;
      color: #0f172a;
      transition: color 0.3s;

      &:hover {
        color: #3b82f6;
      }
    }
  }
}
</style>
